<div *ngIf="tileInstance" class="card" [style.background]="tileInstance?.background">
  <div class="page-section">
    <div class="page-section-content content-container">
      <div
        class="tile-divider top"
        *ngIf="tileInstance.isTileDividerEnabled && tileInstance.tileDividerPosition === 'top'"
        [style.backgroundColor]="tileInstance.tileDividerColor"
      ></div>
      <div class="column-container d-flex fd-row flex-wrap jc-center ai-start gap-60--md">
        <div class="column" *ngFor="let textColumn of tileInstance.textColumns">
          <div
            class="column-divider top"
            *ngIf="textColumn.isDividerEnabled && textColumn.dividerPosition === 'top'"
            [style.backgroundColor]="textColumn.dividerColor"
          ></div>

          <p
            [style.color]="textColumn.headingFontColor"
            [style.fontSize]="textColumn.headingFontSize | pxSuffix"
          >
            {{ textColumn.heading }}
          </p>
          <p
            [style.color]="textColumn.textFontColor"
            [style.fontSize]="textColumn.textFontSize | pxSuffix"
            class="text"
          >
            {{ textColumn.text }}
          </p>

          <div
            class="column-divider bottom"
            *ngIf="textColumn.isDividerEnabled && textColumn.dividerPosition === 'bottom'"
            [style.backgroundColor]="textColumn.dividerColor"
          ></div>
        </div>
      </div>
      <div
        class="tile-divider bottom"
        *ngIf="tileInstance.isTileDividerEnabled && tileInstance.tileDividerPosition === 'bottom'"
        [style.backgroundColor]="tileInstance.tileDividerColor"
      ></div>
    </div>
  </div>
</div>
